<div class="title-container d-flex align-v-center">
  @if (!backLink) {
    <h2 class="c-white">{{ title }}</h2>
  }
  @if (backLink) {
    <h2 class="back-link c-white cursor-pointer" [routerLink]="[backLink]">Back</h2>
  }
  @if (actions) {
    <i class="ml-15 cursor-pointer icon ic-white icon-{{ actions.icon }}" [routerLink]="[actions.link]"></i>
  }
</div>
